const types = {
  SET_LISTA_TRAMITACOES: 'SET_LISTA_TRAMITACOES',
  SET_LISTA_FLUXOS: 'SET_LISTA_FLUXOS',
  SET_DESTINOS_FLUXO: 'SET_DESTINOS_FLUXO',
  SET_VALIDACAO_FLUXO: 'SET_VALIDACAO_FLUXO',
  SET_FLUXO: 'SET_FLUXO',
  SET_DESTINO: 'SET_DESTINO',
  SET_DESPACHO: 'SET_DESPACHO',
  SET_DESPACHO_SALVO: 'SET_DESPACHO_SALVO',
  SET_NIVEL_ACESSO: 'SET_NIVEL_ACESSO',
  SET_HIPOTESE_LEGAL: 'SET_HIPOTESE_LEGAL',
  SET_LISTA_HIPOTESE_LEGAL: 'SET_LISTA_HIPOTESE_LEGAL',
  SET_TIPO_DESPACHO: 'SET_TIPO_DESPACHO',
  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR',
  SHOW_CONFIRMATION_DIALOG: 'ui/SHOW_CONFIRMATION_DIALOG',
  HIDE_CONFIRMATION_DIALOG: 'ui/HIDE_CONFIRMATION_DIALOG',
  SET_DESPACHO_PREPARATORIO: 'SET_DESPACHO_PREPARATORIO'
}

export default types



// WEBPACK FOOTER //
// ./src/vuex/tramitacoes/mutations-types.js